import PropTypes from 'prop-types';
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNav } from '@components/common/context/NavContext';
import { _ } from '@evershop/evershop/src/lib/locale/translate';
import LanguageToggle from '@components/common/locale/LanguageToggle';
import LoginModal from '../../../modules/customer/pages/frontStore/login/LoginModal';
import { useAuth } from '../../../modules/checkout/hooks/useAuth';
export default function BasicMenu(_ref) {
  var {
    basicMenuWidget: {
      menus,
      isMain,
      className
    },
    customer,
    loginApi,
    generateOtpApi,
    verifyOtpApi,
    resetPasswordApi,
    updatePasswordApi,
    createCustomerApi
  } = _ref;
  var {
    activeMobilePanel,
    toggleMenu: toggleNavMenu,
    closeAll
  } = useNav();
  var isOpen = activeMobilePanel === 'menu';
  var [loginModalOpen, setLoginModalOpen] = React.useState(false);
  var {
    customer: authCustomer
  } = useAuth();
  var currentCustomer = authCustomer !== null && authCustomer !== void 0 ? authCustomer : customer;
  React.useEffect(() => {
    if (currentCustomer && loginModalOpen) {
      setLoginModalOpen(false);
    }
  }, [currentCustomer, loginModalOpen]);
  React.useEffect(() => {
    if (isOpen && isMain) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen, isMain]);
  var toggleMenu = () => {
    toggleNavMenu();
  };
  var listingClasses = isMain ? 'md:flex md:justify-center !font-zoom-pro-normal !font-[500] md:space-x-10 absolute md:relative left-[-2.5rem] md:left-0 top-full md:top-auto mt-2 md:mt-0 w-screen md:w-auto md:bg-transparent p-4 md:p-0 min-w-[250px] bg-primary z-[100]  md:divide-y-0 flex flex-col items-center justify-center rtl:md:gap-[8rem] rtl:!font-[400]' : 'flex justify-center !font-zoom-pro-normal !font-[500] space-x-10 relative left-[-2.5rem] md:left-0 top-full md:top-auto mt-2 md:mt-0 w-screen md:w-auto md:bg-transparent p-4 md:p-0 min-w-[250px] bg-primary z-[100]';
  var menuItems = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LanguageToggle, {
    className: "language-toggle flex justify-start md:hidden mt-8 !ml-0"
  }), /*#__PURE__*/React.createElement("li", {
    className: "relative group"
  }, /*#__PURE__*/React.createElement("a", {
    className: "hover:text-gray-300 transition-colors block md:inline-block px-4 py-4 md:px-0 md:py-0 !font-zoom-pro-normal uppercase !font-[500] rtl:!font-[400] rtl:md:text-[16px] w-[200%]",
    href: "https://chicken-kickers.com/"
  }, _('Home'))), menus.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: "relative group md:!ml-[6.6rem]"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/",
    className: "hover:text-gray-300 transition-colors block uppercase md:inline-block px-4 py-4 md:px-0 md:py-0 rtl:!font-[400] rtl:md:text-[16px]"
  }, _('Menu')), item.children.length > 0 && /*#__PURE__*/React.createElement("ul", {
    className: "md:absolute left-0 top-full mt-0 md:mt-3 w-48 bg-primary md:shadow-lg rounded-md md:opacity-0 md:group-hover:opacity-100 md:group-hover:translate-y-0 transform transition-all duration-300 ease-in-out min-w-full md:min-w-[250px]  z-30 md:border-t-4"
  }, item.children.map((subItem, subIndex) => /*#__PURE__*/React.createElement("li", {
    key: subIndex
  }, /*#__PURE__*/React.createElement("a", {
    style: {
      fontSize: '14px'
    },
    href: subItem.url,
    className: "block px-8 md:px-4 py-3 text-gray-700 hover:bg-gray-100"
  }, subItem.name)))))), /*#__PURE__*/React.createElement("li", {
    className: "relative group"
  }, currentCustomer ? /*#__PURE__*/React.createElement("a", {
    style: {
      fontWeight: '500'
    },
    href: "/account",
    className: "hover:text-gray-300 md:hidden  transition-colors block uppercase  px-4 py-4 md:px-0 md:py-0"
  }, _('Profile')) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    style: {
      fontWeight: '500'
    },
    onClick: () => setLoginModalOpen(true),
    className: "hover:text-gray-300 md:hidden transition-colors block uppercase px-4 py-4 md:px-0 md:py-0 bg-transparent border-0 cursor-pointer"
  }, _('Profile'))));
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start gap-6 items-center"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "p-4 relative md:flex md:justify-center"
  }, /*#__PURE__*/React.createElement(LanguageToggle, {
    className: "language-toggle justify-start hidden md:flex"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, isMain && /*#__PURE__*/React.createElement("div", {
    className: "md:hidden"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => {
      e.preventDefault();
      toggleMenu();
    },
    className: "text-black focus:outline-none relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 grid-rows-1 place-items-center"
  }, /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: false
  }, !isOpen ? /*#__PURE__*/React.createElement(motion.div, {
    key: "hamburger",
    initial: {
      opacity: 0,
      scale: 0.8
    },
    animate: {
      opacity: 1,
      scale: 1
    },
    exit: {
      opacity: 0,
      scale: 0.8
    },
    transition: {
      duration: 0.2
    },
    className: "col-start-1 row-start-1"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "26",
    height: "24",
    viewBox: "0 0 26 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 4H25",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12H25",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20L25 20",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round"
  }))) : /*#__PURE__*/React.createElement(motion.div, {
    key: "arrow",
    initial: {
      opacity: 0,
      scale: 0.8
    },
    animate: {
      opacity: 1,
      scale: 1
    },
    exit: {
      opacity: 0,
      scale: 0.8
    },
    transition: {
      duration: 0.2
    },
    className: "col-start-1 row-start-1"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.281 11.0307C19.2114 11.1005 19.1287 11.1558 19.0376 11.1935C18.9466 11.2313 18.849 11.2507 18.7504 11.2507C18.6519 11.2507 18.5543 11.2313 18.4632 11.1935C18.3722 11.1558 18.2894 11.1005 18.2198 11.0307L12.7504 5.56041L12.7504 20.2501C12.7504 20.449 12.6714 20.6398 12.5307 20.7804C12.3901 20.9211 12.1993 21.0001 12.0004 21.0001C11.8015 21.0001 11.6107 20.9211 11.4701 20.7804C11.3294 20.6398 11.2504 20.449 11.2504 20.2501L11.2504 5.56041L5.78104 11.0307C5.64031 11.1715 5.44944 11.2505 5.25042 11.2505C5.05139 11.2505 4.86052 11.1715 4.71979 11.0307C4.57906 10.89 4.5 10.6991 4.5 10.5001C4.5 10.3011 4.57906 10.1102 4.71979 9.96948L11.4698 3.21948C11.5394 3.14974 11.6222 3.09443 11.7132 3.05668C11.8043 3.01894 11.9019 2.99951 12.0004 2.99951C12.099 2.99951 12.1966 3.01894 12.2876 3.05668C12.3787 3.09443 12.4614 3.14974 12.531 3.21948L19.281 9.96948C19.3508 10.0391 19.4061 10.1218 19.4438 10.2129C19.4816 10.3039 19.501 10.4015 19.501 10.5001C19.501 10.5987 19.4816 10.6963 19.4438 10.7873C19.4061 10.8784 19.3508 10.9611 19.281 11.0307Z",
    fill: "#F9F9F9"
  }))))))), /*#__PURE__*/React.createElement("ul", {
    className: "".concat(listingClasses, " hidden md:flex md:flex-row")
  }, menuItems), /*#__PURE__*/React.createElement(AnimatePresence, null, isOpen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(motion.div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    onClick: closeAll,
    className: "fixed inset-0 bg-transparent z-[100] md:hidden h-screen"
  }), /*#__PURE__*/React.createElement(motion.ul, {
    initial: {
      opacity: 0,
      y: -20
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: -20
    },
    transition: {
      duration: 0.3
    },
    className: "".concat(listingClasses, " md:hidden !fixed !top-[60px] !left-0 !mt-[3.4rem] !w-full !z-[110]")
  }, menuItems)))))), /*#__PURE__*/React.createElement(LoginModal, {
    open: loginModalOpen,
    onClose: () => setLoginModalOpen(false),
    loginApi: loginApi,
    generateOtpApi: generateOtpApi,
    verifyOtpApi: verifyOtpApi,
    resetPasswordApi: resetPasswordApi,
    updatePasswordApi: updatePasswordApi,
    createCustomerApi: createCustomerApi
  }));
}
BasicMenu.propTypes = {
  basicMenuWidget: PropTypes.shape({
    menus: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      url: PropTypes.string,
      type: PropTypes.string,
      uuid: PropTypes.string,
      children: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
        type: PropTypes.string,
        uuid: PropTypes.string
      }))
    })),
    isMain: PropTypes.bool,
    className: PropTypes.string
  }).isRequired,
  customer: PropTypes.shape({
    email: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    uuid: PropTypes.string.isRequired
  }),
  createCustomerApi: PropTypes.string,
  generateOtpApi: PropTypes.string,
  loginApi: PropTypes.string,
  resetPasswordApi: PropTypes.string,
  updatePasswordApi: PropTypes.string,
  verifyOtpApi: PropTypes.string
};
BasicMenu.defaultProps = {
  customer: null,
  createCustomerApi: '/api/customers',
  generateOtpApi: '/api/generate-otp',
  loginApi: '/customer/login',
  resetPasswordApi: '/api/customers/reset-password',
  updatePasswordApi: '/api/customers/password',
  verifyOtpApi: '/api/verify-otp'
};
export var query = "\n  query Query($settings: JSON) {\n    basicMenuWidget(settings: $settings) {\n      menus {\n        id\n        name\n        url\n        type\n        uuid\n        children {\n          name\n          url\n          type\n          uuid\n        }\n      }\n      isMain\n      className\n    }\n    customer: currentCustomer {\n      uuid\n      fullName\n      email\n    }\n    loginApi: url(routeId: \"customerLoginJson\")\n    generateOtpApi: url(routeId: \"generateOtp\")\n    verifyOtpApi: url(routeId: \"verifyOtp\")\n    resetPasswordApi: url(routeId: \"resetPassword\")\n    updatePasswordApi: url(routeId: \"updatePassword\")\n    createCustomerApi: url(routeId: \"createCustomer\")\n  }\n";
export var variables = "{\n  settings: getWidgetSetting()\n}";